import { CruzFindVault } from './schema';

let shared: CruzFindVault | null = null;

/** Lazy singleton CruzFindVault — one IndexedDB connection per page. */
export function getSharedVault(): CruzFindVault {
  if (!shared) shared = new CruzFindVault();
  return shared;
}
